import LayoutConfig from "../LayoutConfig";

/**
 * Utility function to determine the content API base URL based on environment
 * @returns The appropriate content API base URL for the current environment
 */
export const getContentApiBaseUrl = (): string => {
  // Check if we're in local development (localhost or 127.0.0.1)
  const isLocalDevelopment =
    typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

  // For local development, use relative URLs that will go through the proxy
  if (isLocalDevelopment) {
    return "/content";
  }

  const region = (LayoutConfig as { region(): string }).region();

  // Use region-specific URLs from environment variables
  switch (region) {
    case "sit":
      return process.env.REACT_APP_CONTENT_API_SIT || "";
    case "beta-1":
      return process.env.REACT_APP_CONTENT_API_STG || "";
    default:
      // Default to production for all other regions (syd-2, us-1, uk-1)
      return process.env.REACT_APP_CONTENT_API_PRD || "";
  }
};

/**
 * Get the email template API base URL
 * @returns The email template API base URL
 */
export const getEmailTemplateApiBaseUrl = (): string => {
  return `${getContentApiBaseUrl()}/api/v1/pages/email-template`;
};

/**
 * Get the email template HTML endpoint URL
 * @param friendlyURL - The friendly URL of the email template
 * @returns The email template HTML endpoint URL
 */
export const getEmailTemplateHtmlUrl = (friendlyURL: string): string => {
  return `${getContentApiBaseUrl()}/api/v1/email-templates/${friendlyURL}/html`;
};

/**
 * Get the email template EML endpoint URL
 * @param friendlyURL - The friendly URL of the email template
 * @returns The email template EML endpoint URL
 */
export const getEmailTemplateEmlUrl = (friendlyURL: string): string => {
  return `${getContentApiBaseUrl()}/api/v1/email-templates/${friendlyURL}/eml`;
};
